module.exports = __webpack_public_path__ + "img/grinder-wooden-spoon-with-spices.42369c4e.jpg";